module.exports = __webpack_public_path__ + "static/media/beto.8f6718b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/beto.jpg
// module id = 550
// module chunks = 0